import { ActivatedRouteSnapshot } from "@angular/router";
import { RouteStore } from "src/app/shared/stores/route-store";

type RouteStoreInstance = InstanceType<typeof RouteStore>;

export function getRouteListContextData<T>(
  routeStore: RouteStoreInstance,
  url: string,
): T | undefined {
  const normalizedUrl = url.startsWith("/") ? url.slice(1) : url;
  return routeStore.getCurrentContext(normalizedUrl)?.data as T | undefined;
}
